<template>
  <v-combobox multiple
    label="Language Proficiencies"
    :value="value" :search-input.sync="language"
    :items="items" no-filter
    append-icon=""
    :color="themes.candidate.light.input"
    @blur="language = ''" @keyup:enter="language = ''"
    @change="modify"
    :menu-props="{ offsetY: true }"
    attach
  >
    <template slot="selection" slot-scope="{ item, selected }">
      <v-chip
        :class="themes.candidate.light.chip"
        :selected="selected"
        close @input="remove(item.id)"
        :key="`language-proficiency-${item.id}`">
        <strong>{{ item.language }}</strong>&nbsp;
        <span>({{ item.description }})</span>
      </v-chip>
    </template>

    <template slot="item" slot-scope="{ item }">
      <v-list-tile-content>
        <v-list-tile-title>{{ item.language }}</v-list-tile-title>
        <v-list-tile-sub-title>{{ item.description }}</v-list-tile-sub-title>
      </v-list-tile-content>
    </template>
  </v-combobox>
</template>

<script>
// Data
import proficiencies from '@/data/language_proficiencies'

// Helpers
import _ from 'lodash'

// Vue Component
export default {
  props: {
    value: Array
  },
  data() {
    return {
      language: ''
    }
  },
  computed: {
    items() {
      if (this.language && this.language.length) {
        return proficiencies.map(p => ({
          language: `${this.language}`,
          proficiency: p.value,
          description: `${p.text}`
        }))
      } else {
        return []
      }
    }
  },
  methods: {
    modify(comboboxValues) {
      // Create any that were newly added
      const newValues = comboboxValues.filter(lp => !lp.id)
      if (newValues.length) this.submit(newValues[0])
      // Remove any that were removed with backspace
      const missingValues = this.value.filter(old => !_.some(comboboxValues, newValue => newValue.id == old.id))
      if (missingValues.length) this.remove(missingValues[0].id)
    },
    submit(languageProficiency) {
      this.$store.dispatch('candidate/languageProficiencies/create', languageProficiency).then(() => {
        this.$store.dispatch('candidate/profile/fetch')
        this.language = ''
      })
    },
    remove(id) {
      this.$store
        .dispatch('candidate/languageProficiencies/destroy', id)
        .then(() => this.$store.dispatch('candidate/profile/fetch'))
    }
  }
}
</script>
